import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { get } from '../../services/apiController';

const LocationDropdown = ({ name, value, locationType, handleChange }) => {
  const [locationList, setLocationList] = useState([]);
  useEffect(() => {
    get(`/branches`)
      .then((response) => {
        setLocationList(response?.data?.rows);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data?.message || err.message);
      });
  }, []);

  return (
    <Form.Select required value={value} name={name} onChange={handleChange} className="input">
      <option value="">All</option>
      {locationList
        .filter((item) => item?.type === locationType)
        .map((item) => (
          <option key={item?.id} value={item?.id}>
            {item?.name}
          </option>
        ))}
    </Form.Select>
  );
};

export default LocationDropdown;
